'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useMemo, useRef } from 'react';
import { useSessionStorage } from '@uidotdev/usehooks';
import { usePathname, useSearchParams } from 'next/navigation';
import { useAnalytics } from './use-analytics';
export function PageView() {
  const $ = _c(12);
  const {
    page
  } = useAnalytics();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const lastUrlRef = useRef("");
  const [source, setSource] = useSessionStorage("__source", "");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {};
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [sourceEvent, setSourceEvent] = useSessionStorage("__source_event", t0);
  let t1;
  bb0: {
    if (!pathname) {
      t1 = "";
      break bb0;
    }
    let fullUrl = window.origin + pathname;
    if (searchParams.toString()) {
      const t2 = fullUrl;
      let t3;
      if ($[1] !== searchParams) {
        t3 = searchParams.toString();
        $[1] = searchParams;
        $[2] = t3;
      } else {
        t3 = $[2];
      }
      fullUrl = t2 + `?${t3}`;
    }
    t1 = fullUrl;
  }
  const url = t1;
  let t2;
  let t3;
  if ($[3] !== page || $[4] !== pathname || $[5] !== setSource || $[6] !== setSourceEvent || $[7] !== source || $[8] !== sourceEvent || $[9] !== url) {
    t2 = () => {
      if (url && url !== lastUrlRef.current) {
        lastUrlRef.current = url;
        if (lastUrlRef.current) {
          setSource(lastUrlRef.current);
        }
        ;
        try {
          page(pathname, {
            url,
            source,
            ...sourceEvent
          });
          setSourceEvent({});
        } catch (t4) {
          const error = t4;
          console.error("Failed to send analytics:", error);
        }
      }
    };
    t3 = [url, pathname, setSource, sourceEvent, source, setSourceEvent, page];
    $[3] = page;
    $[4] = pathname;
    $[5] = setSource;
    $[6] = setSourceEvent;
    $[7] = source;
    $[8] = sourceEvent;
    $[9] = url;
    $[10] = t2;
    $[11] = t3;
  } else {
    t2 = $[10];
    t3 = $[11];
  }
  useEffect(t2, t3);
  return null;
}